import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VMenu, {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": "",
      "min-width": "300",
      "max-width": "300",
      "nudge-left": "12",
      "offset-x": "",
      "transition": "slide-y-transition"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on
      }) {
        return [!_vm.isMobile ? _c('core-button', _vm._g({
          staticClass: "mr-2",
          attrs: {
            "data-cy": "btn_global_help",
            "title": _vm.$i18n_t('Common.drawer.help'),
            "color": _vm.color,
            "solid-icon": "",
            "prepend-icon": "fa-question-circle"
          }
        }, on)) : _c(VBtn, _vm._g({
          attrs: {
            "title": _vm.$i18n_t('Common.drawer.help'),
            "text": "",
            "small": ""
          }
        }, on), [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Common.drawer.help')) + "\n    ")])];
      }
    }])
  }, [_c(VList, {
    attrs: {
      "data-cy": "global_help_menu"
    }
  }, [_c(VListItem, {
    class: _vm.UiTheme ? 'bg-gray-dark' : 'bg-gray',
    attrs: {
      "link": ""
    },
    on: {
      "click": function ($event) {
        _vm.$emit('open-dialog', {
          title: _vm.$i18n_t('Common.help.iLike'),
          type: 'like'
        });
      }
    }
  }, [_c(VListItemTitle, [_c(VIcon, {
    staticClass: "mr-1",
    attrs: {
      "color": _vm.color
    }
  }, [_vm._v("fal fa-grin-beam")]), _vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.help.iLike')) + "\n      ")], 1)], 1), _c(VListItem, {
    class: _vm.UiTheme ? 'bg-gray-dark' : 'bg-gray',
    attrs: {
      "link": ""
    },
    on: {
      "click": function ($event) {
        _vm.$emit('open-dialog', {
          title: _vm.$i18n_t('Common.help.iDontLike'),
          type: 'dontLike'
        });
      }
    }
  }, [_c(VListItemTitle, [_c(VIcon, {
    staticClass: "mr-1",
    attrs: {
      "color": _vm.color
    }
  }, [_vm._v("fal fa-frown")]), _vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.help.iDontLike')) + "\n      ")], 1)], 1), _c(VListItem, {
    class: _vm.UiTheme ? 'bg-gray-dark' : 'bg-gray',
    attrs: {
      "link": ""
    },
    on: {
      "click": function ($event) {
        _vm.$emit('open-dialog', {
          title: _vm.$i18n_t('Common.help.suggestionTitle'),
          type: 'suggestion'
        });
      }
    }
  }, [_c(VListItemTitle, [_c(VIcon, {
    staticClass: "mr-1",
    attrs: {
      "color": _vm.color
    }
  }, [_vm._v("fal fa-marker")]), _vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.help.suggestion')) + "\n      ")], 1)], 1), _c(VDivider, {
    staticClass: "mt-2 ml-3 mr-3"
  }), _vm.showSystemStatus ? _c(VListItem, {
    attrs: {
      "link": "",
      "href": `${this.$store.state.app.systemStatus}`,
      "target": "_blank"
    }
  }, [_c(VListItemTitle, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.help.systemStatus')) + "\n        "), _c('span', {
    staticClass: "external-link"
  }, [_c(VIcon, {
    staticClass: "external-link-icon",
    attrs: {
      "color": _vm.color
    }
  }, [_vm._v("fal fa-external-link")])], 1)])], 1) : _vm._e(), _c(VDivider, {
    staticClass: "mt-2 ml-3 mr-3"
  }), _c(VListItem, {
    attrs: {
      "link": "",
      "href": `${this.$store.state.app.releaseNotesURL}`,
      "target": "_blank"
    }
  }, [_c(VListItemTitle, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.help.new')) + "\n        "), _c('span', {
    staticClass: "external-link"
  }, [_c(VIcon, {
    staticClass: "external-link-icon",
    attrs: {
      "color": _vm.color
    }
  }, [_vm._v("fal fa-external-link")])], 1)])], 1), _c(VDivider, {
    staticClass: "mt-2 ml-3 mr-3"
  }), _c(VListItem, {
    attrs: {
      "link": "",
      "href": _vm.manualPath,
      "target": _vm.$route.meta && !_vm.$route.meta.internalHelp ? '_blank' : ''
    }
  }, [_c(VListItemTitle, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.help.manual')) + "\n        "), _vm.$route.meta && !_vm.$route.meta.internalHelp ? _c('span', {
    staticClass: "external-link"
  }, [_c(VIcon, {
    staticClass: "external-link-icon",
    attrs: {
      "color": _vm.color
    }
  }, [_vm._v("fal fa-external-link")])], 1) : _vm._e()])], 1), _c(VDivider, {
    staticClass: "mt-2 ml-3 mr-3"
  }), _c(VListItem, {
    attrs: {
      "link": "",
      "to": "/api",
      "active-class": "no-active"
    }
  }, [_c(VListItemTitle, [_vm._v(_vm._s(_vm.$i18n_t('Common.drawer.api')))])], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };